import PalommaLogo from "../PalommaLogo";
import OrganizationListItem from "./OrganizationListItem";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

type DiscoveredOrganization = {
  organization: {
    organization_id: string;
    organization_name: string;
    organization_slug: string;
  };
  membership: {
    type: string;
    details: object | null;
  };
};

type OrganizationSelectorProps = {
  discoveredOrgs: DiscoveredOrganization[];
  signupData: {
    companyName: string;
  } | null;
  selectedOrgId: string | null;
  isJoiningOrg: boolean;
  isCreatingOrg: boolean;
  onJoinOrganization: (org: DiscoveredOrganization) => void;
  onCreateNewOrganization: () => void;
};

const OrganizationSelector = ({
  discoveredOrgs,
  signupData,
  selectedOrgId,
  isJoiningOrg,
  isCreatingOrg,
  onJoinOrganization,
  onCreateNewOrganization,
}: OrganizationSelectorProps): JSX.Element => {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-8">
      <div className="flex w-full max-w-[35rem] flex-col gap-6">
        <div className="mb-2 flex justify-center">
          <PalommaLogo height={75} width={75} />
        </div>

        <div className="w-full rounded-2xl bg-white p-10 shadow-xl">
          <div className="flex flex-col gap-6">
            <div className="mb-2 text-center">
              <h2 className="mb-2 text-2xl font-bold">
                {signupData ? "Organizaciones Encontradas" : "Selecciona tu Organización"}
              </h2>
              <p className="text-gray-600">
                {signupData
                  ? "Tu correo electrónico está asociado con las siguientes organizaciones:"
                  : "Elige la organización a la que deseas acceder:"
                }
              </p>
            </div>

            <div className="rounded-lg border border-gray-200 bg-gray-50 p-6">
              <ul className="flex flex-col gap-3">
                {discoveredOrgs.map((org) => (
                  <OrganizationListItem
                    key={org.organization.organization_id}
                    organization={org}
                    isLoading={isJoiningOrg && selectedOrgId === org.organization.organization_id}
                    onJoin={onJoinOrganization}
                  />
                ))}
              </ul>
            </div>

            {signupData && (
              <div className="border-t-2 border-gray-200 pt-4">
                <p className="mb-4 text-center text-gray-600">
                  ¿O prefieres crear una nueva organización para <strong>{signupData.companyName}</strong>?
                </p>
                <Button
                  onClick={onCreateNewOrganization}
                  className="w-full"
                  variant="outline"
                  size="lg"
                  disabled={isCreatingOrg}
                >
                  {isCreatingOrg && <Loader2 className="size-4 animate-spin" />}
                  {isCreatingOrg ? "Creando organización..." : "Crear Nueva Organización"}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationSelector;
